const myModal = new Modal();
const myClobalLoader = new Preloader({
  clobalLader: true,
});

loadDom(() => {
  const footerBtnContact = document.querySelector('.contacts-call--footer');
  const dataMaskInputs = document.querySelectorAll('input[data-tel-mask]');
  footerBtnContact.addEventListener('click', showContactsCall);
  formatInputTel(dataMaskInputs);
  detectAdminPanel();
  detectHoverHeader();
  animationFloatBtn();
  replaceSearchBtn();
  showFloatContacts();
  sendFeedback();
  animTemplate();
  getOnceMenu();
});

// document.addEventListener("readystatechange", () => {
//   if (document.readyState === "complete") {
//     animTemplate();
//   }
// });

function showFloatContacts() {
  const btnFloat = document.querySelector(".float-call__btn");
  const floatBlock = document.querySelector(".contacts-float");
  btnFloat.addEventListener("click", function () {
    floatBlock.classList.add("show");
  });
  floatBlock.addEventListener("click", function (event) {
    let target = event.target;
    if (!target.closest("[data-close-float]")) return;
    floatBlock.classList.remove("show");
  });
}

function makeBottomPanel() {
  const widthMakePanel = 1050;
  const currentWidth = bodyClientWidth();

  const panel = createNode('div', {
    className: 'md-panel',
  });
  const btnMobSearch = createNode('div', {
    className: 'md-search-btn btn-reset',
  });
}

function showContactsCall() {
  const btnMain = this;
  const dataName = btnMain.dataset.contactBtn;
  const contentCall = document.querySelector(`[data-contact-pos=${dataName}]`);

  let contentCallOb = contentCall.getBoundingClientRect();
  if (btnMain.classList.contains('show-numbers')) {
    contentCall.classList.remove('open');
    btnMain.classList.remove('show-numbers');
    if (contentCall.querySelector(".contacts__phone-top")) {
      contentCall.removeChild(contentCall.querySelector(".contacts__phone-top"));
    }

    return;
  }


  if (contentCallOb.left + contentCallOb.width > bodyClientWidth()) {
    contentCall.classList.add('pos-rigth');
    return;
  }
  contentCall.classList.add('pos-left');
  const topContainerContactsPopup = createNode('div', {
    className: 'contacts__phone-top df al-c ju-b',
  });
  const closeBtn = createNode('button', {
    className: '_close btn-reset',
    type: 'button',
  });
  const noticeContactsPopup = createNode('p', {
    className: 'contacts__phone-notice mr-reset',
    textContent: btnMain.dataset.textCallBtn,
  });
  topContainerContactsPopup.appendChild(noticeContactsPopup);
  topContainerContactsPopup.appendChild(closeBtn);
  contentCall.prepend(topContainerContactsPopup);


  contentCall.classList.add('open');
  btnMain.classList.add('show-numbers');
  closeBtn.addEventListener('click', () => {
    contentCall.classList.remove('open');
    contentCall.removeChild(topContainerContactsPopup);
    btnMain.classList.remove('show-numbers');
  });
}

function closeNoticeTop(event) {
  const tl = gsap.timeline({
    defaults: {
      duration: 0.12,
      ease: 'power3.out',
    },
  });

  if (event.target.closest('.sale-notice__btn')) {
    this.classList.add('hide');
    tl.fromTo(
      this,
      {
        opacity: 1,
        height: this.scrollHeight,
      },
      {
        opacity: 0,
        height: 0,
      },
      '<100%'
    ).to(this, {
      visibility: 'hidden',
    });
  }
  return;
}

function detectAdminPanel() {
  const adPanel = document.getElementById('bx-panel');
  const header = document.getElementById('header');
  const hero = document.getElementById('hero');
  if (hero) {
    header.classList.add('float');
  } else {
    if (document.documentElement.classList.contains("dark-scheme")) {
      document.documentElement.classList.remove("dark-scheme");
      document.documentElement.classList.add("light-scheme");
    }
  }
  if (adPanel) {
    if (header.classList.contains('float')) {
      header.style.paddingTop = `${adPanel.offsetHeight + 10}px`;
    }
  }
}

function detectHoverHeader() {
  const header = document.getElementById("header");
  let flag = false;

  header.addEventListener("mouseenter", function (evt) {
    this.classList.add("hover");
  });
  header.addEventListener("mouseleave", function (evt) {
    let currentTarget = evt.currentTarget;
    const searchBlock = currentTarget.querySelector("#search");
    flag = searchBlock.classList.contains("_show") ? true : false;
    if (!flag) {
      this.classList.remove("hover");
    }
    ;

  });
  return true;
}

function animationFloatBtn() {
  const tl = gsap.timeline({
    defaults: {
      duration: 0.7,
      ease: "power1.inOut",
    },
    delay: .5,
    repeat: -1
  });

  tl.fromTo(".float-call__btn-icon--phone", {
    opacity: 0,
  }, {
    opacity: 1,
  })
    .addPause(">", gsap.delayedCall, [2, () => {
      tl.play();
      gsap.set(".float-call__btn-icon--phone", {opacity: 0});
    }])
    .fromTo(".float-call__btn-icon--tg", {
      opacity: 0,
    }, {
      opacity: 1,
    })
    .addPause(">", gsap.delayedCall, [2, () => {
      tl.play();
      gsap.set(".float-call__btn-icon--tg", {opacity: 0});
    }])
    .fromTo(".float-call__btn-icon--wt", {
      opacity: 0,
    }, {
      opacity: 1,
    })
    .addPause(">", gsap.delayedCall, [2, () => {
      tl.play();
      gsap.set(".float-call__btn-icon--wt", {opacity: 0});
    }])
    .fromTo(".float-call__btn-icon--email", {
      opacity: 0,
    }, {
      opacity: 1,
    })
    .addPause(">", gsap.delayedCall, [1, () => {
      tl.play();
      gsap.set(".float-call__btn-icon--email", {opacity: 0});
    }]);
}

function replaceSearchBtn() {
  const btn = document.querySelector(".search-btn");
  const blockInsert = document.querySelector(".header__actions");
  if (document.body.clientWidth > 768 || document.body.scrollWidth > 768 || document.body.offsetWidth > 768) {
    blockInsert.prepend(btn);
  }
}

function animTemplate() {
  const header = document.getElementById("header");
  header.classList.add('lHeader');
  const anim = gsap.timeline({
    defaults: {
      duration: .3,
      ease: "power1.inOut",
    },
  });

  anim.to(".preloadPage", {
    opacity: 0,
    onComplete: function () {
      gsap.set(".preloadPage", {zIndex: 0, pointerEvents: "none"});
    }
  })
    .fromTo(".header__container", {
      y: -50,
      opacity: 0
    }, {
      y: 0,
      opacity: 1
    }, ">5%");

}

function sendFeedback() {
  const formFeedBack = document.getElementById("feedback-from");

  if (!formFeedBack) return false;
  formFeedBack.reset();
  const preload = new Preloader({clobalLader: true});
  formFeedBack.addEventListener('submit', async (e) => {
    e.preventDefault();
    const form = e.target;
    let data = {
      'name': form.elements.name.value,
      'telephone': form.elements.telephone.value,
      'email_subject': form.elements.email_subject.value,
    };
    let dataSend = `request=${JSON.stringify(data)}`;
    let url = `/ajax/mail/feedback.php?${new Date().getTime()}`;
    const xhr = new XMLHttpRequest();
    preload.showPreloader();
    xhr.open('POST', url, true);
    xhr.responseType = 'text';
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.setRequestHeader("Cache-Control", "no-cache, no-store, max-age=0");
    xhr.addEventListener('readystatechange', () => {
      if (xhr.readyState === 4 && xhr.status === 200) {
        preload.closePreloader();
        const noticeMail = noticeModal(data, 'sendMail');

        let timeLine = new TimelineMax({defaults: {duration: .22, ease: "sine.inOut"}});
        timeLine.fromTo(noticeMail, {
          right: '-150%',
        }, {
          right: bodyClientWidth() > 500 ? '12px' : '5px'
        })
          .to(noticeMail, {
            right: '-150%',
            onComplete: () => {
              document.body.removeChild(noticeMail);
            }
          }, '1.8');

        myModal.close("formOderProduction");
        formFeedBack.reset();
        if (typeof window.carrotquest !== "undefined") {

          carrotquest.track('Контакт с формы обратная связь', {
            "$name": data.name,
            "$phone": data.telephone
          });
          carrotquest.identify([
            {op: 'update_or_create', key: '$phone', value: data.telephone},
            {op: 'update_or_create', key: '$name', value: data.name},
          ]);
        }
        if (typeof window.ym != "undefined") {
          ym(22647787, 'reachGoal', 'feedback');
        }
      }
    });
    xhr.send(dataSend);
    data["nameForm"] = "feedback";
    let rsMailB24 = await fetch(`/ajax/local/create_lead_b24.php?${new Date().getTime()}`, {
      method: 'POST',
      body: JSON.stringify(data)
    })
      .then(resp => resp.json())
      .then(dataForm => dataForm);
  });
  formFeedBack.elements.telephone.addEventListener('input', inputValues);
}
function getOnceMenu() {
  const btnBurger = document.getElementById("burger");
  if (!btnBurger) return;

  btnBurger.addEventListener('click', async (evt) => {
    if (btnBurger.classList.contains('loaded')) return;
    btnBurger.classList.add('loaded');
    const rsMenu = await fetch(`/ajax/menu/lazymenu.php`, {
      method: 'POST',
    })
      .then(response => response.text())
      .then(data => {
        let wrapperResponse = createNode('html');
        wrapperResponse.innerHTML = data;
        let includeElement = wrapperResponse.querySelector('.slinky_menu');
        let includeElementOverlay = wrapperResponse.querySelector('.slinki_over');
        document.body.appendChild(includeElement);
        document.body.appendChild(includeElementOverlay);
        let processed = BX.processHTML(data, false);
        BX.ajax.processScripts(processed.SCRIPT);
        return data;
      });

    document.querySelector('.slinky_menu').classList.add('slinky_menu_show');
    document.querySelector('.slinki_over').classList.add('slinki_over_show');
  })
}